import React, { useMemo, useContext } from 'react';
import Gradient, { GRADIENT_ID } from './gradient.component';
import HoverLine from './hover-line.component';
import { Bar } from './hover-bar.styles';
import { calculateBarProperties } from './hover-bar.utils';
import { ChartContext } from '../../contexts';
import { colors } from '@keen.io/colors/';
export var hoverBarMotion = {
    initial: { opacity: 0.3 },
    animate: { opacity: 1 },
    transition: { duration: 0.3 },
    exit: { opacity: 0 },
};
var HoverBar = function (_a) {
    var x = _a.x, y = _a.y, _b = _a.showLine, showLine = _b === void 0 ? true : _b, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    var _c = useContext(ChartContext), svgDimensions = _c.svgDimensions, margins = _c.margins, type = _c.theme.hoverBar.type;
    var _d = useMemo(function () {
        return {
            xMin: margins.left,
            xMax: svgDimensions.width - margins.right,
        };
    }, [margins.left, margins.right, svgDimensions.width]), xMin = _d.xMin, xMax = _d.xMax;
    var _e = calculateBarProperties({
        x: x,
        y: y,
        xMin: xMin,
        xMax: xMax,
        svgDimensions: svgDimensions,
        margins: margins,
    }), width = _e.width, height = _e.height, barX = _e.barX, barY = _e.barY;
    var color = type === 'dark' ? colors.black[500] : colors.gray[100];
    var opacity = type === 'dark' ? '.1' : '0.2';
    return (React.createElement(React.Fragment, null,
        React.createElement(Gradient, { color: color }),
        React.createElement(Bar, { fill: "url(#" + GRADIENT_ID + ")", fillRule: "evenodd", opacity: opacity, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, x: barX, y: barY, width: width, height: height }),
        showLine && React.createElement(HoverLine, { x1: x, x2: x, y1: barY, y2: barY + height })));
};
export default HoverBar;
